import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CompanyContext } from '../../contexts'
import {
  setCurrentCompany as setCurrentCompanyAction,
  setEditCompanyModalVisibility as setEditCompanyModalVisibilityAction,
} from '../../slices/company_slice'

export default function Row({ company = null, request = null }) {
  const dispatch = useDispatch()
  const { activeIndex } = useSelector((state) => state.company)
  const { company_types } = useContext(CompanyContext)

  const onClickEditButton = () => {
    dispatch(setCurrentCompanyAction(company))
    dispatch(setEditCompanyModalVisibilityAction(true))
  }

  const renderActions = () => {
    switch (activeIndex) {
      case 0:
        return <ApprovedCompanyActions onClickEditButton={onClickEditButton} />
      case 2:
        return <RejectedCompanyActions />
      default:
        break
    }
  }

  return (
    <>
      <tr>
        <td>{company.name}</td>
        <td>
          {company.company_aliases.map((alias, key) => (
            <div key={key}>{alias.name}</div>
          ))}
        </td>
        <td>{company.logo_url && <img src={company.logo_url} width={32}></img>}</td>
        <td>{company.company_type}</td>
        <td>{company.status}</td>
        <td>
          <div className="dome-d-flex dome-gap12">{renderActions()}</div>
        </td>
      </tr>
    </>
  )
}

function ApprovedCompanyActions({ onClickEditButton }) {
  return (
    <>
      <button className="dome-btn dome-btn-base dome-btn-aqua-stroke" onClick={onClickEditButton}>
        Edit
      </button>
    </>
  )
}

function RejectedCompanyActions() {
  return <p>No actions</p>
}
